import React from "react";

import {
  ADMIN_MENU_ITEMS,
  ORG_ADMIN_MENU_ITEMS,
  LOC_ADMIN_MENU_ITEMS,
  ADMIN_AS_ORG_ADMIN_MENU_ITEMS,
} from "./const";
import { converMenuItemToElement } from "./utils";
import { useMeWithOrganizationImpersonation } from "../../hooks/organizationImpersonation";
import { AccountData, AccountType } from "../../models/AccountData";
import { getEnvironment } from "../../utils/getEnvironment";

import "./styles.scss";

const selectMenuItems = (me?: AccountData) => {
  if (!me) return [];

  if (me.type === AccountType.ADMIN && me?.is_impersonating) {
    return ADMIN_AS_ORG_ADMIN_MENU_ITEMS;
  } else if (me.type === AccountType.ADMIN) {
    return ADMIN_MENU_ITEMS;
  } else if (me.type === AccountType.ORG_ADMIN) {
    return ORG_ADMIN_MENU_ITEMS;
  } else if (me.type === AccountType.LOC_ADMIN) {
    return LOC_ADMIN_MENU_ITEMS;
  }

  return [];
};

export const LeftMenu: React.FunctionComponent = () => {
  const me = useMeWithOrganizationImpersonation();
  const menuItems = selectMenuItems(me);

  const environment = getEnvironment();

  return (
    <div className="left-nav">
      {environment !== "production" && (
        <div className="environment-banner">
          <p>{environment}</p>
        </div>
      )}
      <ul>{menuItems.map((item) => converMenuItemToElement(item, me))}</ul>
    </div>
  );
};

export default LeftMenu;
